module.exports = __webpack_public_path__ + "static/media/arrow-right.427cbcc2.svg";